import React from 'react';
import ReactDOM from 'react-dom';
import {HashRouter, BrowserRouter} from "react-router-dom";
import {Provider} from 'react-redux';
import { get } from 'lodash';
import {MuiThemeProvider as NewMuiThemeProvider, createMuiTheme} from '@material-ui/core/styles';
import {addLocaleData} from 'react-intl';

import {setLocaleMessages} from "./opencell/actions/PageModule";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import {getUrlParameters} from './opencell/pages/utils/UrlUtils';

import Error from './opencell/model/Error';
import App from './opencell/App.jsx';

import AuthorizationService from './opencell/services/AuthorizationService';
import UserService from './opencell/services/UserService';
import ApplicationStore from './opencell/framework/ApplicationStore';

import {initializeUser} from "./opencell/actions/UserActions";
import {loadContactDetails} from "./opencell/actions/CustomerActions";
import {loadUserAccount} from "./opencell/actions/UserAccountActions";
import {getProviderCF} from "./opencell/actions/ProviderActions";

const {location = {}} = window;
const isSecuredPage = location && location.pathname && location.pathname.indexOf(secured) !== -1;
const auth = AuthorizationService.auth;

const i18nLocaleData = {
	en: () => System.import('react-intl/locale-data/en'),
	fr: () => System.import('react-intl/locale-data/fr'),
	es: () => System.import('react-intl/locale-data/es')
};

const theme = createMuiTheme({
	overrides: {
		MuiTabs: { // Name of the component ⚛️
			root: { // Name of the rule
				flexGrow: 1, // Some CSS
				width: '100%',
				background: 'white',
				color: 'black',
			},
			indicator: {
				background: '#97D5E0',
			},
		},
		MuiTab: {
			label: {
				fontSize: '1.5rem!important',
				textTransform: 'none'
			},
			textColorInherit: {
				opacity: 1,
			}
		},
		MuiSvgIcon: {
			colorPrimary: {
				color: "red"
			}
		}
	},
});
//pplicationStore.subscribe (()=> {console.log("state reducer :" , ApplicationStore.getState());})
const resume = (error) => {

	if (!error) {
		ReactDOM.render(
		<Provider store={ApplicationStore}>
			<BrowserRouter>
				<NewMuiThemeProvider theme={theme}>
					<MuiThemeProvider>
						<App auth={auth}/>
					</MuiThemeProvider>
				</NewMuiThemeProvider>
			</BrowserRouter>
		</Provider>, document.getElementById('selfcare'));
	} else {
		setInterval(() => {
			auth.logout({redirectUri: REDIRECT_URL});
		}, 2000);
		ReactDOM.render(<h3>{error.message + " Redirecting to login..."}</h3>, document.getElementById('selfcare'));
	}
};


auth.init({})
	.success(authenticated => {
		if (authenticated) {
			const locale = (!!auth &&  !!auth.tokenParsed && auth.tokenParsed.locale) || "es";
			// initialize react-intl locale
			const messages = locale ? `/i18n/${locale}.json?V=${i18n_VERSION}` : `/i18n/es.json?V=${i18n_VERSION}`;
			i18nLocaleData[locale]().then(localeData => { addLocaleData(localeData)});
			ApplicationStore.dispatch(setLocaleMessages(messages));
			// load provider details
			ApplicationStore.dispatch(getProviderCF());
			// Load userAccount details
			ApplicationStore.dispatch(loadUserAccount((userAccount, err1) => {
				if(err1){
					resume(err1);
				} else if( userAccount ){
					ApplicationStore.dispatch(initializeUser(auth, (user, err3) => {
						if (err3) {
							resume(err3);
						} else if (user) {
							resume();
						}
					}));
				}
			}));
		} else if (!authenticated && isSecuredPage) {
			const loginUrl = auth.createLoginUrl({idpHint:KC_IDP});
			window.location.replace(loginUrl);
		} else {
			resume();
		}
	})
	.error(function () {
		resume(new Error());
	});



// WEBPACK FOOTER //
// ./src/main.js